var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9935 49.9814C41.0356 49.9814 49.987 41.0333 49.987 29.9952C49.987 18.9572 41.0356 10.0091 29.9935 10.0091C18.9514 10.0091 10 18.9572 10 29.9952C10 41.0333 18.9514 49.9814 29.9935 49.9814Z",
    fill: "#0072E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.987 29.9952H29.9935V49.9814H49.987V29.9952Z",
    fill: "#0072E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9935 99.9734C41.0356 99.9734 49.987 91.0253 49.987 79.9872C49.987 68.9492 41.0356 60.0011 29.9935 60.0011C18.9514 60.0011 10 68.9492 10 79.9872C10 91.0253 18.9514 99.9734 29.9935 99.9734Z",
    fill: "#E9004C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.987 79.9872H29.9935V99.9734H49.987V79.9872Z",
    fill: "#E9004C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7419 15.845C63.8799 17.7016 62.4027 19.907 61.3948 22.3352C60.3868 24.7633 59.868 27.3664 59.868 29.9952C59.868 32.6241 60.3868 35.2271 61.3948 37.6552C62.4027 40.0834 63.8799 42.2889 65.7419 44.1454L94.026 15.8717C92.171 14.0127 89.9678 12.5373 87.5422 11.5298C85.1165 10.5223 82.5161 10.0025 79.8894 10C77.2628 9.99753 74.6614 10.5125 72.2339 11.5154C69.8064 12.5183 67.6004 13.9895 65.7419 15.845Z",
    fill: "#C45227"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7419 44.1454C67.5986 46.0026 69.8032 47.4759 72.2298 48.4811C74.6563 49.4863 77.2573 50.0037 79.8839 50.0037C82.5106 50.0037 85.1115 49.4863 87.5381 48.4811C89.9646 47.4759 92.1693 46.0026 94.026 44.1454L65.7419 15.845C63.8799 17.7015 62.4027 19.907 61.3948 22.3351C60.3868 24.7633 59.868 27.3663 59.868 29.9952C59.868 32.6241 60.3868 35.2271 61.3948 37.6552C62.4027 40.0833 63.8799 42.2888 65.7419 44.1454Z",
    fill: "#C45227"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.004 99.9734C91.0461 99.9734 99.9975 91.0253 99.9975 79.9872C99.9975 68.9492 91.0461 60.0011 80.004 60.0011C68.9619 60.0011 60.0105 68.9492 60.0105 79.9872C60.0105 91.0253 68.9619 99.9734 80.004 99.9734Z",
    fill: "#008563"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0371 100H80.0306V60.0011H60.0371V100Z",
    fill: "#008563"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar);
export default __webpack_public_path__ + "static/media/default-avatar.3c246fd50ea97a4ddf7e6051bd206aaf.svg";
export { ForwardRef as ReactComponent };